<h3 class="headline-24 my-3">{{ 'generalInformation' | translate }}</h3>
<div class="row">
  <div class="col-lg-6">
    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'displayName' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.primaryData?.name | baseIsEmpty }}</div>
    </div>

    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'companyName' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.primaryData?.legalName | baseIsEmpty }}</div>
    </div>

    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'idNum' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.primaryData?.vatId | baseIsEmpty }}</div>
    </div>

    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'consent' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.collectiveAgreement | baseIsEmpty }}</div>
    </div>
  </div>

  <div class="col-lg-6">
    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'email' | translate }}</span>
      </div>
      <div class="w-50">
        {{ providerDetails?.contact?.email | baseIsEmpty }}
        <i
          *ngIf="providerDetails?.contact?.email"
          class="fa-solid fa-fw fa-copy ms-1 pointer"
          (click)="copyToClipboard(providerDetails?.contact?.email)"
        ></i>
      </div>
    </div>

    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'landlinePhone' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.contact?.phone | baseIsEmpty }}</div>
    </div>

    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'phoneMobile' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.contact?.mobilePhone | baseIsEmpty }}</div>
    </div>

    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'fax' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.contact?.fax | baseIsEmpty }}</div>
    </div>

    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'website' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.contact?.website | baseIsEmpty }}</div>
    </div>
  </div>
</div>

<h3 class="headline-24 mt-4 mb-3">{{ 'businessAddress' | translate }}</h3>
<div class="row">
  <div class="col-12 col-lg-6">
    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'streetHouseNumber' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.businessAddress.street | baseIsEmpty }}</div>
    </div>
  </div>

  <div class="col-12 col-lg-6">
    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'zipAndCity' | translate }}</span>
      </div>
      <div class="w-50">
        {{ providerDetails?.businessAddress.postCode | baseIsEmpty }}
        {{ providerDetails?.businessAddress.city | baseIsEmpty }}
      </div>
    </div>
  </div>
</div>

<h3 class="headline-24 mt-4 mb-3">{{ 'billingAddress' | translate }}</h3>
<div class="row">
  <div class="col-12 col-lg-6">
    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'streetHouseNumber' | translate }}</span>
      </div>
      <div class="w-50">{{ providerDetails?.billingAddress.street | baseIsEmpty }}</div>
    </div>
  </div>

  <div class="col-lg-6">
    <div class="d-flex flex-row justify-content-between py-2">
      <div class="w-50">
        <span class="column-headline">{{ 'zipAndCity' | translate }}</span>
      </div>
      <div class="w-50">
        <ng-container *ngIf="providerDetails?.billingAddress.postCode">
          {{ providerDetails?.billingAddress.postCode }}
        </ng-container>
        {{ providerDetails?.billingAddress.city | baseIsEmpty }}
      </div>
    </div>
  </div>
</div>

<h3 class="headline-24 mt-4">{{ 'document.plural' | translate }}</h3>
<div class="listview p-0">
  <div class="listview-header my-2">
    <div class="row">
      <div class="col-3">{{ 'name' | translate }}</div>
      <div class="col-3">{{ 'category' | translate }}</div>
      <div class="col-2">{{ 'dateTime.validUntil' | translate }}</div>
      <div class="col-1"></div>
    </div>
  </div>
  <div *ngFor="let document of documents">
    <base-master-data-document
      [readonly]="true"
      [document]="document"
      [emitOnly]="true"
      [documentCategories]="documentCategories"
      (selectDocumentEvent)="downloadDocument($event, document)"
    ></base-master-data-document>
  </div>
  <base-empty-list-row
    *ngIf="documents.length === 0"
    [backgroundSecondary]="true"
    [hideBackgroundImage]="true"
    message="document.emptyList"
  ></base-empty-list-row>
</div>

<ng-template #documentViewerTemplate>
  <base-document-viewer
    [src]="activeDocumentSrc"
    [title]="activeDocument.name"
    [fileName]="activeDocument.originalFilename"
    [fileType]="activeDocument.type"
    [modalRef]="documentViewerModalRef"
    (downloadImage)="downloadDocument($event, { document: activeDocument, categoryLabel: '' })"
  ></base-document-viewer>
</ng-template>
